<div class="map-controls">
    <button (click)="resetMapView()">Re Center</button>
  </div>
  <div #fullMap [ngClass]="classFromParent"></div>
  